if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarouselBanner = context => {

  const carouselBanner = context.closest('.shopify-section');

  const slidesContainer = carouselBanner.querySelector('.carousel-banner__container');
  const slides = slidesContainer.querySelectorAll('.swiper-wrapper .swiper-slide');
  const slidesCount = slides.length;

  if (slidesCount > 1) {

    const swiper = new Swiper(slidesContainer.querySelector('.carousel-banner__blocks-container'), {
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: slidesContainer.querySelector('.carousel-banner__dots'),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        },
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.carousel-banner'), function (el) {
    window.dAgency.initCarouselBanner(el);
  })
} else {
  document.addEventListener('DOMContentLoaded', function () {
    [].forEach.call(document.querySelectorAll('.carousel-banner'), function (el) {
      window.dAgency.initCarouselBanner(el);
    })
  });
}
